




























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import CardTitle from '@/components/common/CardTitle.vue';
import Decisions from '@/store/modules/Decisions';
import Apps from '@/store/modules/Apps';
import { Decision } from '@/api/model/Decision';
import AppTemplateCard from '@/components/apps/AppTemplateCard.vue';
import { API, Storage } from 'aws-amplify';
import ValueTypes from '@/utils/ValueTypes';

const decisionsModule = getModule(Decisions);
const appsModule = getModule(Apps);

@Component({
    name: 'CardDesignPreviewContent',
    components: {
        AppTemplateCard,
    },
    directives: {},
})
export default class CardDesignPreviewContent extends Vue {

    private DEFAULT_IMAGE_URL = ValueTypes.DEFAULT_IMAGE_URL;

    @Prop({
        default: () => {
            return {};
        },
        type: Object,
    })
    item!: any;


    private noImageUrl = this.DEFAULT_IMAGE_URL.PREVIEW_DEFAULT;
    private imageUrl: string = '';
    get decisionTemplateDetailsDictionary() {
        return appsModule.decisionTemplateDetailsDictionary;
    }

    // get itemDetail() {
    //     if (this.item && this.item.decisionIdRef) {
    //         return appsModule.decisionTemplateDetailsDictionary[this.item.decisionIdRef];
    //     } else {
    //         return null;
    //     }
    // }

    mounted() {
        // this.getImage();
    }

    @Watch('item', { deep: true })
    onItemDetailChange() {
        // this.getImage();
    }

    private async getImage() {
        if (this.item && this.item.templateImagePage) {
            let res = await Storage.get(this.item.templateImagePage);
            this.imageUrl = res.toString();
        }
    }

    get appTemplates() {
        return appsModule.appTemplates;
    }

    get appTemplatesBaseOnDecision() {
        if (this.appTemplates && this.item) {
            return this.appTemplates.filter((app) => app.decisionIdRef === this.item.decisionIdRef);
        }
    }

    get relatedDecisions() {
        return decisionsModule.relatedDecisions[this.item.id];
    }

    private navigateDecision(decisionId: string) {
        const getUrl = window.location;
        const url = getUrl.origin + '/template/builder?decisionId=' + decisionId;
        window.open(url, '_blank');
    }

}
